import { Component } from '@angular/core';

@Component({
  selector: 'app-lists-widget6',
  templateUrl: './lists-widget6.component.html',
})
export class ListsWidget6Component {
  // Flag to control visibility of the schedule
  showSchedule: boolean = false;

  // Mock schedule data for the weekly schedule
  weeklySchedule = [
    { day: 'Monday', active: true, start: '06:00', end: '16:00' },
    { day: 'Tuesday', active: true, start: '06:00', end: '16:00' },
    { day: 'Wednesday', active: true, start: '06:00', end: '16:00' },
    { day: 'Thursday', active: true, start: '06:00', end: '16:00' },
    { day: 'Friday', active: true, start: '06:00', end: '16:00' },
    { day: 'Saturday', active: false, start: null, end: null },
    { day: 'Sunday', active: false, start: null, end: null },
  ];

  // Toggle the visibility of the schedule
  toggleSchedule(): void {
    this.showSchedule = !this.showSchedule;
  }
}
